module.exports = __webpack_public_path__ + "img/preview-4.9bbfdb2c.png";